import apiHandler from "../core/apiHandler";

const paymentConditionApi = apiHandler('payment-conditions');
export default paymentConditionApi;